// extracted by mini-css-extract-plugin
export default {"user":"user_user__Yud8O","informacion":"user_informacion__OTyUm","tituloUser":"user_tituloUser__oKe41","botones":"user_botones__gw0S1","backButton":"user_backButton__MxK1e"};